import React, { useMemo } from 'react';
import './managed-apps-select/managed-apps-select.scss';
import { observer } from 'mobx-react-lite';
import { Popover } from 'antd';
import ClearIcon from '@svg/x-icon.svg?react';
import { ListItem } from '../../shared/entity-selector/entity-selector';

interface SelectedAppsLabelProps {
    selectedList: ListItem[];
    labels: ListItem[];
    remove: (id: string) => void;
}

export const SelectedAppsLabel: React.FC<SelectedAppsLabelProps> = observer((
    {selectedList, labels, remove}) => {

    const hiddenLabels = useMemo(() =>
            selectedList.filter(app => !labels.includes(app))
        , [labels]);

    const LabelTooltipContent = () =>
        <div className={'tooltip-label'}>
        {hiddenLabels.map(label =>
            <span key={label.key} className={'label-wrapper'}>
                <span className={'label'}>{label.key.toUpperCase()}</span>
                <button type="button" className={'label-remove'} aria-label={`Remove ${label.key.toUpperCase()}`} onClick={() => remove(label.key)}><ClearIcon/></button>
            </span>)}
    </div>;

    return <div className={'labels'}>
        {labels.map((labelData) =>
            <span key={labelData.key} className={'label-wrapper'}>
                {labelData.name.startsWith('+') ?
                    <Popover content={<LabelTooltipContent/>}
                             className={`selected-apps-tooltip`}
                             overlayClassName={`apps-label-popover-list`}
                             showArrow={true}
                             placement={'rightTop'}>
                        <span className={'label'}>{labelData.name}</span>
                    </Popover> : <>
                        <span className={'label'}>{labelData.name}</span>
                        <button type="button" className={'label-remove'} aria-label={`Remove ${labelData.name}`} onClick={() => remove(labelData.key)}><ClearIcon/></button>
                    </>}
            </span>)}
    </div>;
});